module.exports = __webpack_public_path__ + "img/avatar0.c820fd19.png";